<script setup lang="ts">
import {DialogHeader} from "@/core/components/ui/dialog";
import {cn} from "@/lib/utils";
import type {Component} from "vue";

defineProps<{
    icon: Component;
    colorClass?: string;
    bgClass?: string;
}>();
</script>

<template>
  <DialogHeader>
    <div :class="cn('self-start p-3 rounded-lg', bgClass ?? 'bg-primary/20')">
      <component :is="icon" :class="cn('size-5', colorClass ?? 'text-primary')" />
    </div>
  </DialogHeader>
</template>
